import MinorCurrencyRatio from "./MinorCurrencyRatio";

/**
 * Price-handling utilities
 *
 * Expects all input prices to be expressed as integers in pennies.
 * 
 * Original author @heron-web/material (no longer maintained)
 */
class PriceUtils {

	/**
	 * Convert a price value to a string for display.
	 * 
	 * @param {Integer} price Pennies
	 * @param {String} currency optional Currency symbol (`£`)
	 * @return {String}
	 */
	static getDisplayString(price, currency="£") {
		price = ((price / 100)?.toFixed(2)?.toString()?.split(".") || []);
		const pounds = (price[0] || "0");
		const pence = (price[1]?.padEnd(2, "0") || "00");
		return `${((pounds < 0) ? "-" : "")}${currency}${Math.abs(pounds)}.${pence}`;
	}


	/**
	 * Format a number as currency using intl library.
	 * 
	 * @param {int} value in minor currency units (the smallest unit of a currency)
	 * @returns {string} The formatted currency value
	 */
	static getDisplayStringIntl(value, locale="en-GB", currencyUnit="GBP", minorUnitDivisor=MinorCurrencyRatio.Two) {

		// Return a locale-specific currency string.
		// eslint-disable-next-line no-undef
		return new Intl.NumberFormat(locale,
			{
				style: "currency",
				currency: currencyUnit
			}).format(value / minorUnitDivisor);

	}


	/**
	 * rounds up a number to the closest denomination
	 * @param {number} cashDue the amount that is due in pence e.g. 1499
	 * @param {number} denomination the denomination that is available in note form e.g. 5, 10, 20, 50
	 * @returns the amount due rounded up to the next denomination (e.g. £4.89 > £5 note, £17 > £20 note)
	 */
	static getCashDueCeil(cashDue, denomination) {
		return Math.ceil(cashDue / (denomination)) * denomination;
	}

}

export default PriceUtils;
